import { mapTextError } from "../set-player-name/mapTextError";
export var checkForTextError = function (path) { return function (action, state$) {
    if (mapTextError.has(action.statusCode)) {
        return path;
    }
    return undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/errors/checkForTextError.ts
// module id = 1849
// module chunks = 3